import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { availableSubjects, default_subjectIcon_path, subjectIcon_path } from 'projects/selflearnv2-ui/src/app/constants/app.constants';
import { SelfLearnService } from 'projects/selflearnv2-ui/src/app/services/self-learn/self-learn.service';

@Component({
  selector: 'app-resume-learning-card',
  templateUrl: './resume-learning-card.component.html',
  styleUrls: ['./resume-learning-card.component.css']
})
export class ResumeLearningCardComponent implements OnInit {
  @Input() data:any;
  @Input() isFromHomeScreen:boolean;
  subjectName:any;
  @Input() subjectData:any;

  constructor(public selfLearnService: SelfLearnService,public router: Router) { }

  ngOnInit(): void {

  }

  getSubjectIcon(subjectName: any) {
    if (subjectName != null){
      const found = availableSubjects.find((element: any) => element.toLowerCase() == subjectName.toLowerCase());
      return (found) ? subjectIcon_path + found + '-new-icon.svg'
        : default_subjectIcon_path + '.svg';
    }else{
      return false;
    }
  }
  navigateToResumeLearning(){
    if(this.isFromHomeScreen){
    if(this.data.type == 'video'){
      this.setLocalStorageForPlaybackScreen(this.data.data)
    }else if(this.data.type =='flashcard'){
      this.navigateToTopicDetails(this.data.data);

    }else{
      this.navigateToPracticetest(this.data.data)
    }
  }else{
    this.goToVideoPlaylistSceen();
  }

  }
  goToVideoPlaylistSceen(){
    localStorage.setItem("selfLearnSelectedSubject",this.data.subjectId);
    localStorage.setItem('selfLearnSelectedSubjectName',this.subjectData.nodeName);
    localStorage.setItem("chapterName",this.data.topicName);
    localStorage.setItem("chapterId",this.data.chapterId);
    localStorage.setItem("selfLearnSelectedTopicId", this.data.topicId)
    localStorage.setItem("selfLearnSelectedTopicName",this.data.name)
    localStorage.setItem('selfLearnSelectedVideoId', this.data.videoId)
    localStorage.setItem('selectedTopicName',this.data.topicName);
    localStorage.setItem('isFromHomeScreen',this.isFromHomeScreen.toString());
    localStorage.setItem("selfLearnPreviousPage",'subject');
    this.router.navigateByUrl("selfLearn-V2/videoplayback");
  }
  setLocalStorageForPlaybackScreen(videoData:any){
    localStorage.setItem("selfLearnPreviousPage", 'chapter');
    localStorage.setItem('selfLearnSelectedSubjectName',this.subjectData.nodeName);
    localStorage.setItem("selfLearnSelectedSubject",videoData.subjectId);
    localStorage.setItem("chapterId",videoData.chapterId);
    localStorage.setItem("chapterName",videoData.topicName);
    localStorage.setItem("selfLearnSelectedTopicId", videoData.topicId)
    localStorage.setItem("selfLearnSelectedTopicName",videoData.name)
    localStorage.setItem('selfLearnSelectedVideoId', videoData.id)
    localStorage.setItem('selectedTopicName',videoData.name);
    localStorage.setItem('isFromHomeScreen',this.isFromHomeScreen.toString());
    this.router.navigateByUrl("selfLearn-V2/videoplayback");
  }
  navigateToTopicDetails(flashcardData:any){
    localStorage.setItem("selfLearnSelectedSubject",flashcardData.subjectId);
    localStorage.setItem('selfLearnSelectedSubjectName',this.subjectData.nodeName);
    localStorage.setItem("chapterId",flashcardData.chapterId);
    localStorage.setItem("chapterName",flashcardData.topicName);
    localStorage.setItem("selfLearnSelectedTopicId", flashcardData.topicId);
    localStorage.setItem("selfLearnSelectedTopicName", flashcardData.name);
    localStorage.setItem('isFromHomeScreen',this.isFromHomeScreen.toString());
    let flashcardDetails:any = {
      "subjectId": flashcardData.subjectId,
      "topicId": flashcardData.topicId,
      "topicName": flashcardData.topicName,
      // "subtopicsCount": 9,
      // "publishedFlashcardCount": 5,
      // "publishedVideoCount": 9,
      // "flashcardTaggedQuestionsCount": 17
  }
    localStorage.setItem("SelectedFlashcardData", JSON.stringify(flashcardDetails));
    this.router.navigateByUrl("selfLearn-V2/topic-summary-details");
  }
  navigateToPracticetest(topicData:any) {
    //localStorage.setItem('subtopicCount', topicData.subtopicCount);
    localStorage.setItem("selfLearnSelectedSubject",topicData.subjectId);
    localStorage.setItem('selfLearnSelectedSubjectName',this.subjectData.nodeName);
    localStorage.setItem("chapterId",topicData.chapterId);
    localStorage.setItem("chapterName",topicData.topicName);
    localStorage.setItem("selfLearnSelectedTopicId", topicData.topicId);
    localStorage.setItem("selfLearnSelectedTopicName", topicData.name);
    localStorage.setItem('isFromHomeScreen',this.isFromHomeScreen.toString());
    // localStorage.setItem('currentLevel', topicData.levelsInProgress);
    // if(topicData.levelsCompleted == 4){this.router.navigate([`selfLearn-V2/practice-completion`]);}
    this.router.navigate([`selfLearn-V2/practice-questions`]);

  }

}
